// Hindi: mobile tab bar, More sheet, page names, sign-in page and NFC button. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " and ": " और ",
  ".": " से सहमत होते हैं।",
  "By signing in, you agree to AssetOS ": "साइन इन करके, आप AssetOS की ",
  "Terms of Service": "सेवा की शर्तों",
  "Privacy Policy": "गोपनीयता नीति",
  "API & Webhooks": "API और वेबहुक",
  "Account Subscription & Plans": "खाता सदस्यता और प्लान",
  "All {app} Modules": "{app} के सभी मॉड्यूल",
  "Allow NFC for this site to read tags.": "टैग पढ़ने के लिए इस साइट को NFC की अनुमति दें।",
  "Asset Custody & Movements": "एसेट अभिरक्षा और स्थानांतरण",
  "Asset Disposals & Write-Offs": "एसेट निपटान और बट्टे खाते",
  "Asset Lookup": "एसेट खोजें",
  "Asset Quick View": "एसेट त्वरित दृश्य",
  "Asset Valuation & Analytics Dashboard": "एसेट मूल्यांकन और एनालिटिक्स डैशबोर्ड",
  "Audit": "ऑडिट",
  "Audit Reconciliation Console": "ऑडिट मिलान कंसोल",
  "Banquet Event Kits": "बैंक्वेट इवेंट किट",
  "Banquet Event Kits & Batch Reconciliation": "बैंक्वेट इवेंट किट और बैच मिलान",
  "Blind Counts & Variance Console": "ब्लाइंड गिनती और अंतर कंसोल",
  "Books": "बही",
  "Camera Scan HUD": "कैमरा स्कैन",
  "Catalogue": "कैटलॉग",
  "Connected Platforms": "जुड़े प्लेटफ़ॉर्म",
  "Contents": "सामग्री",
  "Corporate Email Address": "कॉर्पोरेट ईमेल पता",
  "Demo": "डेमो",
  "Demo accounts — 1-click test sign-in": "डेमो खाते — 1-क्लिक परीक्षण साइन-इन",
  "Demo sign-in failed": "डेमो साइन-इन विफल रहा",
  "Depreciation Runs & GL Schedules": "मूल्यह्रास रन और GL शेड्यूल",
  "Email or password is incorrect": "ईमेल या पासवर्ड गलत है",
  "Enter your work email first so we can find your organisation’s sign-in.": "पहले अपना कार्य ईमेल दर्ज करें ताकि हम आपके संगठन का साइन-इन ढूँढ सकें।",
  "Enterprise Hospitality Fixed Asset Operating System": "एंटरप्राइज़ हॉस्पिटैलिटी फिक्स्ड एसेट ऑपरेटिंग सिस्टम",
  "Event Kits": "इवेंट किट",
  "Exception Queue": "अपवाद कतार",
  "Exceptions": "अपवाद",
  "Field App": "फ़ील्ड ऐप",
  "First Scan": "पहला स्कैन",
  "First Scan Walk Binding": "पहला स्कैन वॉक बाइंडिंग",
  "First-Scan Walk": "पहला-स्कैन वॉक",
  "Forgot Password": "पासवर्ड भूल गए",
  "Forgot password?": "पासवर्ड भूल गए?",
  "Guest Loaners": "मेहमान लोनर",
  "Guest Loaners & Overdue Tracker": "मेहमान लोनर और ओवरड्यू ट्रैकर",
  "Hold the tag to the phone…": "टैग को फ़ोन से सटाएँ…",
  "How to get access": "एक्सेस कैसे पाएँ",
  "IAS 16 cost model with USALI operating department allocation and automated Xero GL manual journals.": "USALI परिचालन विभाग आवंटन और स्वचालित Xero GL मैनुअल जर्नल के साथ IAS 16 लागत मॉडल।",
  "Inwarding & Asset Tagging": "आवक और एसेट टैगिंग",
  "Integration Fabric Connectors": "इंटीग्रेशन फ़ैब्रिक कनेक्टर",
  "Linen Laundry": "लिनन लॉन्ड्री",
  "Loaners": "लोनर",
  "Maintenance Incident Logging": "रखरखाव घटना दर्ज करना",
  "Maintenance Incidents": "रखरखाव घटनाएँ",
  "Maintenance incidents": "रखरखाव घटनाएँ",
  "Maintenance incidents: {count} active": "रखरखाव घटनाएँ: {count} सक्रिय",
  "Mobile App Navigation": "मोबाइल ऐप नेविगेशन",
  "Mobile Physical Audits & Par Management": "मोबाइल भौतिक ऑडिट और पार प्रबंधन",
  "NFC is switched off or not available on this phone.": "इस फ़ोन पर NFC बंद है या उपलब्ध नहीं है।",
  "Need an account? ": "खाता चाहिए? ",
  "OR": "या",
  "Offline": "ऑफ़लाइन",
  "Offline-ready room audits, deterministic conflict resolution, and pooled inventory par replenishment.": "ऑफ़लाइन कमरा ऑडिट, निश्चित टकराव समाधान, और पूल्ड इन्वेंटरी पार भरपाई।",
  "Offline: actions are saved on this device and synced later": "ऑफ़लाइन: कार्य इस डिवाइस पर सहेजे जाते हैं और बाद में सिंक होते हैं",
  "Opening Inventory": "प्रारंभिक इन्वेंटरी",
  "Password": "पासवर्ड",
  "Password is required": "पासवर्ड आवश्यक है",
  "Physical Audit Verification": "भौतिक ऑडिट सत्यापन",
  "Please enter a valid corporate email address": "कृपया मान्य कॉर्पोरेट ईमेल पता दर्ज करें",
  "Property & Location Registry": "प्रॉपर्टी और स्थान रजिस्टर",
  "Quick View": "त्वरित दृश्य",
  "Room Contents Sheet": "कमरे की सामग्री शीट",
  "Room Kit Templates & Stamping": "रूम किट टेम्पलेट और स्टैम्पिंग",
  "Room Stamping & Opaque ULID Tags": "रूम स्टैम्पिंग और अपारदर्शी ULID टैग",
  "Sign In": "साइन इन",
  "Sign In to Dashboard": "डैशबोर्ड में साइन इन करें",
  "Sign in to manage hotel property fixed assets and operations": "होटल प्रॉपर्टी की फिक्स्ड एसेट और संचालन प्रबंधित करने के लिए साइन इन करें",
  "Sign in with your organisation": "अपने संगठन से साइन इन करें",
  "Sign-in with your organisation did not complete. Please try again or use your email and password.": "संगठन से साइन-इन पूरा नहीं हुआ। फिर से कोशिश करें या ईमेल और पासवर्ड का उपयोग करें।",
  "Sign-in with your organisation was cancelled.": "संगठन से साइन-इन रद्द कर दिया गया।",
  "Single IFRS Book & USALI Allocations": "एकल IFRS बही और USALI आवंटन",
  "Single sign-on could not be started. Use your email and password.": "सिंगल साइन-ऑन शुरू नहीं हो सका। अपना ईमेल और पासवर्ड उपयोग करें।",
  "Standardized room kit blueprints with tamper-evident QR codes and 6-character short codes.": "छेड़छाड़-रोधी QR कोड और 6-अक्षर शॉर्ट कोड के साथ मानक रूम किट ब्लूप्रिंट।",
  "Stock": "स्टॉक",
  "Stock & Par": "स्टॉक और पार",
  "Stock Points & Par": "स्टॉक पॉइंट और पार",
  "Stock Points & Par Management": "स्टॉक पॉइंट और पार प्रबंधन",
  "Streamlined property onboarding, room-level asset stamping, physical audit walks, native repair records, and automated single-book IAS 16 depreciation.": "सरल प्रॉपर्टी ऑनबोर्डिंग, कमरा-स्तर एसेट स्टैम्पिंग, भौतिक ऑडिट वॉक, मरम्मत रिकॉर्ड, और स्वचालित एकल-बही IAS 16 मूल्यह्रास।",
  "Sync": "सिंक",
  "Sync Status": "सिंक स्थिति",
  "Tag Generation & Binding": "टैग बनाना और बाइंडिंग",
  "Tag Generation & Binding Console": "टैग निर्माण और बाइंडिंग कंसोल",
  "Tag Studio": "टैग स्टूडियो",
  "Tap NFC tag": "NFC टैग टैप करें",
  "That sign-in attempt expired. Please try again.": "वह साइन-इन प्रयास समाप्त हो गया। कृपया फिर से कोशिश करें।",
  "The tag could not be read. Hold the phone still against it and try again.": "टैग पढ़ा नहीं जा सका। फ़ोन को उस पर स्थिर रखें और फिर कोशिश करें।",
  "There is no AssetOS account for this email. Ask your administrator for an invitation.": "इस ईमेल के लिए कोई AssetOS खाता नहीं है। अपने एडमिनिस्ट्रेटर से आमंत्रण माँगें।",
  "This account belongs to a different organisation. Use your email and password instead.": "यह खाता किसी अन्य संगठन का है। इसके बजाय अपना ईमेल और पासवर्ड उपयोग करें।",
  "This invitation has already been used. Sign in with your organisation again.": "यह आमंत्रण पहले ही उपयोग हो चुका है। अपने संगठन से फिर से साइन इन करें।",
  "Toggle password visibility": "पासवर्ड दिखाएँ/छिपाएँ",
  "User Registration": "उपयोगकर्ता पंजीकरण",
  "Uses your organisation’s sign-in. Only people your administrator has invited can get in.": "आपके संगठन का साइन-इन उपयोग करता है। केवल आपके एडमिनिस्ट्रेटर द्वारा आमंत्रित लोग ही प्रवेश कर सकते हैं।",
  "Welcome back": "फिर से स्वागत है",
  "Work Orders & Repair Management": "वर्क ऑर्डर और मरम्मत प्रबंधन",
  "Your organisation has not verified this email address.": "आपके संगठन ने इस ईमेल पते को सत्यापित नहीं किया है।",
  "Your organisation is not set up for single sign-on. Use your email and password.": "आपका संगठन सिंगल साइन-ऑन के लिए सेट नहीं है। अपना ईमेल और पासवर्ड उपयोग करें।",
  "field screens": "फ़ील्ड स्क्रीन",
  "{count} waiting to sync": "{count} सिंक की प्रतीक्षा में",
};
